import cloudinary from '../../../../../utils/cloudinary';
import calculateSizes from '../../../../../utils/calculate-image-sizes';

export default getImageUrl;

function getImageUrl(imageId, height, width, options) {
  options = Object.assign(
    {
      crop: 'limit',
      height: height,
      width: width
    },
    options || {}
  );

  var imageSize = calculateSizes.image(options.width, options.height);

  options = Object.assign(options, imageSize);

  return imageId && cloudinary.url(imageId, options);
}
